import { motion } from "framer-motion";
import { ShieldCheck, Cpu, Zap, Globe } from "lucide-react";

const pillars = [
  {
    label: "Security First",
    desc: "Enterprise-grade protection for every digital asset.",
    icon: <ShieldCheck className="w-8 h-8" />,
    color: "#018CF1",
  },
  {
    label: "AI Integration",
    desc: "Leveraging neural networks to automate complex workflows.",
    icon: <Cpu className="w-8 h-8" />,
    color: "#05DFAD",
  },
  {
    label: "High Velocity",
    desc: "Rapid deployment cycles without compromising stability.",
    icon: <Zap className="w-8 h-8" />,
    color: "#EAB308",
  },
  {
    label: "Global Scale",
    desc: "Architecture designed to support millions of concurrent users.",
    icon: <Globe className="w-8 h-8" />,
    color: "#018CF1",
  },
];

export default function CorePillars() {
  return (
    <section className="relative py-16 md:py-24 bg-[#0B0F19] overflow-hidden">
      {/* Matching background glow from your Solutions page */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[#018CF1]/5 blur-[80px] md:blur-[120px] rounded-full -z-10" />

      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {pillars.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -10 }}
              className="group relative p-6 md:p-8 rounded-[20px] md:rounded-[32px] bg-[#161B22]/40 backdrop-blur-xl border border-white/5 hover:border-[#018CF1]/30 transition-all duration-500">
              {/* Icon Container */}
              <div
                className="w-12 h-12 md:w-16 md:h-16 rounded-xl md:rounded-2xl bg-[#0B0F19] flex items-center justify-center mb-4 md:mb-6 border border-white/10 group-hover:shadow-[0_0_20px_rgba(1,140,241,0.2)] transition-all duration-500"
                style={{ color: item.color }}>
                {item.icon}
              </div>

              <h3 className="text-lg md:text-xl font-black text-white uppercase italic tracking-tighter mb-2 md:mb-3">
                {item.label}
              </h3>

              <p className="text-slate-400 text-xs md:text-sm leading-relaxed font-medium">
                {item.desc}
              </p>

              {/* Decorative Corner Accent */}
              <div
                className="absolute bottom-4 md:bottom-6 right-4 md:right-6 w-6 h-6 md:w-8 md:h-8 opacity-10 group-hover:opacity-100 transition-opacity duration-500"
                style={{
                  background: `linear-gradient(135deg, transparent 50%, ${item.color} 50%)`,
                  clipPath: "polygon(100% 0, 100% 100%, 0 100%)",
                  borderRadius: "0 0 6px 0 md:rounded-[0_0_8px_0]",
                }}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
